module.exports = __webpack_public_path__ + "img/v2.aeed1b28.png";